<template>
  <div>
    <template v-if="!selectedBillingcustomer">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <input ref="search" type="text" class="form-control" :placeholder="searchPlaceholder" v-model="search" /> 
          </div>
        </div>
      </div>
      <div class="row" v-if="searching">
        <div class="col-xs-12">
          <div class="well">
            <i class="fa fa-fw fa-cog fa-spin"></i> {{ _('Loading...') }}
          </div>
        </div>
      </div>
      <div class="row" v-if="noResults">
        <div class="col-xs-12">
          <div class="well">
            {{ _('No results found.') }}
          </div>
        </div>
      </div>
      <billingcustomer-item v-for="bc in billingCustomers" :customer="bc" :key="bc.id" :selected="false" :baseDomain="baseDomain" :shopId="shopId" :apiKey="apiKey" v-on:selectCustomer="selectCustomer" v-on:selectBillingcustomer="selectBillingcustomer" />
      <button class="btn btn-default" v-on:click="createNew"><i class="fa fa-fw fa-plus"></i> {{ _('Create new billing customer') }}</button>
    </template>
    <template v-else>
      <h4>{{ _('Billing Customer') }}</h4>
      <billingcustomer-item :customer="selectedBillingcustomer" :selected="true" :baseDomain="baseDomain" :shopId="shopId" :apiKey="apiKey" v-on:selectCustomer="selectCustomer" v-on:selectBillingcustomer="selectBillingcustomer" />
      <template v-if="!selectedCustomer">
        <h4 v-if="sortedCustomers && sortedCustomers.length">{{ _('Select client from the billing customer\'s linked clients') }}</h4>
        <customer-item v-for="c in sortedCustomers" :key="c.id" :customer="c" :selected="false" :baseDomain="baseDomain" :shopId="shopId" :apiKey="apiKey" v-on:selectCustomer="selectCustomer" />
        <h4 v-if="sortedCustomers && sortedCustomers.length">{{ _('Select other client') }}</h4>
        <div v-else>
          <p><strong>{{ _('There are no clients linked to the selected billing customer.') }}</strong></p>
          <h4>{{ _('Select client') }}</h4>
        </div>
        <customer-search :skip-focus="true" :baseDomain="baseDomain" :shopId="shopId" :apiKey="apiKey" v-on:selectCustomer="selectCustomer" />
      </template>
      <template v-else>
        <h4>{{ _('Client') }}</h4>
        <customer-item :customer="selectedCustomer" :selected="true" :baseDomain="baseDomain" :shopId="shopId" :apiKey="apiKey" v-on:selectCustomer="selectCustomer" />
      </template>
    </template>
  </div>
</template>

<script>

import events from '~/lib/events'
import modals from '~/lib/modals'
import { ModalBillingCustomerDetails as BillingCustomerDetails, BillingcustomerItem, CustomerItem, CustomerSearch } from '#components'
import customersearch from '~/lib/customersearch'
import axios from 'axios'
import debounce from 'lodash/debounce'

export default {
  props: ['baseDomain', 'shopId', 'apiKey', 'skipFocus'],
  mixins: [customersearch, events, modals],
  data () {
    return {
      billingCustomers: [],
      updatedWhileCreating: [],
      creatingNew: false,
      column: {
        identifier: 'billingcustomersearch',
        component: {
          id: 1
        }
      },
      newBillingcustomerId: null
    }
  },
  computed: {
    searchPlaceholder () {
      return this._('Find a billing customer (name, company id, email, linked client name)')
    },
    sortedCustomers () {
      if (!this.selectedBillingcustomer || !this.selectedBillingcustomer.sharedCustomer || !this.selectedBillingcustomer.sharedCustomer.length) {
        return []
      }
      return [...this.selectedBillingcustomer.sharedCustomer].sort((a, b) => a.name > b.name ? 1 : -1)
    },
    noResults () {
      if (!this.searching && (!this.billingCustomers || !this.billingCustomers.length) && this.search && this.search.length >= this.minLength) {
        return true
      }
      return false
    }
  },
  methods: {
    createNew () {
      this.creatingNew = true
      this.updatedWhileCreating = []
      this.showModal('billingcustomerdetails', BillingCustomerDetails, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          component: {
            initData: {
              billingCustomer: {
                company: this.search
              },
              modal: true
            }
          }
        },
        events: {
          save: this.billingcustomerCreated
        },
        handlers: {},
        width: 1000
      })
      return
    },
    billingcustomerCreated (customer) {
      this.creatingNew = false
      if (customer) {
        this.newBillingcustomerId = parseInt(customer.id, 10)
        if (this.updatedWhileCreating.includes(this.newBillingcustomerId)) {
          this.loadAndSelectBillingcustomer(this.newBillingcustomerId)       
        }
      }
    },
    clearSearch () {
      this.billingCustomers = []
    },
    doSearch: debounce(async ($this) => {
      $this.searching = true // Redundant, done in the watcher but leaving here in case we call this directly
      $this.billingCustomers = await $this.searchBillingcustomers($this.search)
      $this.searching = false
    }, 250),
    async loadAndSelectBillingcustomer (id) {
      this.selectedBillingcustomer = await this.loadBillingcustomer(id)
      this.$emit('selectBillingcustomer', this.selectedBillingcustomer)
    },
    loadBillingcustomer (id) {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/billingcustomers/' + id + '.json?apikey=' + this.apiKey)
        } catch (e) {
          resolve(null)
          return
        }
        resolve(response.data)
      })
    }
  },
  components: {
    BillingcustomerItem,
    CustomerItem,
    CustomerSearch
  },
  async mounted () {
    if(!this.events) {
      let events = {}
      events['billingCustomerUpdate'] = async (message) => {
        if (!message || !message.data) {
          return
        }
        const id = parseInt(message.data.id, 10)
        if (this.selectedBillingcustomer && parseInt(this.selectedBillingcustomer.id, 10) === id) {
          this.selectedBillingcustomer = await this.loadBillingcustomer(id)
        }
        if (this.newBillingcustomerId === id) {
          this.selectedBillingcustomer = await this.loadBillingcustomer(id)
          this.$emit('selectBillingcustomer', this.selectedBillingcustomer)
        }
        if(this.creatingNew) {
          this.updatedWhileCreating.push(id)
        }
        const foundIndex = this.billingCustomers.findIndex(c => parseInt(c.id, 10) === id)
        if (foundIndex !== -1) {
          const customer = await this.loadBillingcustomer(id)
          if (customer) {
            this.billingCustomers[foundIndex] = customer
          }
        }
      }
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>